import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {OccupationalProfileService} from './occupational-profile.service';
import {CommonModule} from '@angular/common';
import {OccupationalProfileComponent} from './occupational-profile.component';
import {BaseInfoModule} from '../base-info/base-info.module';
import {InfoPackageModule} from '../info-package/info-package.module';
import {CompetencesModule} from '../competences/competences.module';
import {MovieModule} from '../movie/occupational-profile-movie.module';
import {ChartsModule} from '../chart/occupational-profile-charts.module';
import {OrientationModule} from '../orientation/orientation.module';
import {TechnicalErrorModule} from '../technical-error/technical-error.module';
import {ExternalLinkResolver, ExternalRouteComponent} from '../core/external-route.component';

@NgModule({
    imports: [
        BaseInfoModule,
        CommonModule,
        CompetencesModule,
        InfoPackageModule,
        OrientationModule,
        MovieModule,
        ChartsModule,
        TechnicalErrorModule
    ],
    providers: [
        OccupationalProfileService,
		ExternalLinkResolver
    ],
    declarations: [
		ExternalRouteComponent,
        OccupationalProfileComponent
    ],
    exports: [
        OccupationalProfileComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class OccupationalProfileModule {

}
